import {connect} from 'react-redux';
import Login from './login';

export default connect(({users, account, token, errors}) => ({users, account, token, errors}))(Login);


// WEBPACK FOOTER //
// ./src/components/users/auth/index.js